// PLP/carousel card USP tooltips: the CSS-positioned panel gets clipped by
// slider containers (overflow: hidden) and mispositioned by Flickity's
// transforms. On hover we portal the panel to <body> with fixed coordinates
// so it escapes every clipping/stacking context; on leave it goes back.
// Hover-only, like the rest of the card USP interaction.

function initCardUspTooltips() {
  const PANEL_WIDTH = 300;
  let openTip = null;
  let closeTimer = null;

  const close = () => {
    if (!openTip) return;
    const { el, home } = openTip;
    el.removeAttribute('style');
    home.appendChild(el);
    openTip = null;
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 120);
  };

  const open = (usp) => {
    const tip = usp.querySelector('.price-usp__info-box');
    if (!tip) return;
    clearTimeout(closeTimer);
    if (openTip && openTip.el !== tip) close();
    if (openTip && openTip.el === tip) return;

    const rect = usp.getBoundingClientRect();
    const width = Math.min(PANEL_WIDTH, window.innerWidth - 16);
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - width - 8));

    openTip = { el: tip, home: tip.parentNode };
    document.body.appendChild(tip);
    tip.style.position = 'fixed';
    tip.style.top = rect.bottom + 6 + 'px';
    tip.style.left = left + 'px';
    tip.style.right = 'auto';
    tip.style.width = width + 'px';
    tip.style.opacity = '1';
    tip.style.visibility = 'visible';
    tip.style.zIndex = '9999';

    tip.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    tip.addEventListener('mouseleave', scheduleClose);
  };

  document.addEventListener('mouseover', (e) => {
    const usp = e.target.closest && e.target.closest('.price-usp--card');
    if (usp) open(usp);
  });
  document.addEventListener('mouseout', (e) => {
    const usp = e.target.closest && e.target.closest('.price-usp--card');
    if (usp && !(e.relatedTarget && usp.contains(e.relatedTarget))) scheduleClose();
  });
  // Any scroll shifts the anchor — just close.
  document.addEventListener('scroll', close, { passive: true, capture: true });
}

initCardUspTooltips();
